import React from 'react';
import PropTypes from 'prop-types';
import PostCard from '../PostCard';
import EditorialDetailModalFrame from '../../molecules/EditorialDetailModalFrame';

/**
 * Editorial post-detail modal. Renders the existing `PostCard` with its
 * full comments + reactions flow inside the shared detail frame.
 */
export default function PostDetailModal({
  post,
  currentUserId,
  onClose,
  dropdownOpenId,
  onToggleDropdown,
  onDelete,
  onPostMetaChange,
  onEditPost,
  readOnly = false,
}) {
  if (!post) return null;

  return (
    <EditorialDetailModalFrame
      onClose={onClose}
      ariaLabel="Post details"
      closeLabel="Close post"
    >
      <PostCard
        post={post}
        currentUserId={readOnly ? null : currentUserId}
        dropdownOpenId={dropdownOpenId}
        onToggleDropdown={readOnly ? null : onToggleDropdown}
        onDelete={readOnly ? null : onDelete}
        onPostMetaChange={onPostMetaChange}
        onEditPost={readOnly ? null : onEditPost}
        readOnly={readOnly}
        defaultShowComments
        editorialEngagement
        hideActionsMenu
      />
    </EditorialDetailModalFrame>
  );
}

PostDetailModal.propTypes = {
  post: PropTypes.object,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  dropdownOpenId: PropTypes.string,
  onToggleDropdown: PropTypes.func,
  onDelete: PropTypes.func,
  onPostMetaChange: PropTypes.func,
  onEditPost: PropTypes.func,
  readOnly: PropTypes.bool,
};
